export const pageMetadata = {
  home: {
    title: "Simplifyte | Workflow Management Software for CA Firms & Professional Teams",
    description:
      "Simplifyte helps CA firms, tax consultants, advocates and professional service teams manage client-wise work, FY/period tracking, documents, deadlines, reviews, approvals, reminders and closure proof.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  docs: {
    title: "Simplifyte Academy | Guides & Tutorials",
    description:
      "Explore guides, tutorials, and practical help to get the most out of Simplifyte.",
    image: "https://www.simplifyte.com/og/academy.jpg",
  },
  pricing: {
    title: "Simplifyte Pricing | Plans for CA Firms & Professional Teams",
    description:
      "Choose a Simplifyte plan that fits your CA firm or professional service team — transparent INR pricing with no hidden costs.",
    image: "https://www.simplifyte.com/og/pricing.jpg",
  },
  contactSales: {
    title: "Contact Sales | Simplifyte",
    description:
      "Talk to our team about how Simplifyte can replace WhatsApp, Excel and email chaos in your CA firm or professional service practice.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  contact: {
    title: "Contact Simplifyte | CA Firms & Professional Teams",
    description:
      "Reach out to Simplifyte for sales, support, or product questions. We work with CA firms, tax consultants, advocates and professional service teams.",
    image: "https://www.simplifyte.com/og/contact.jpg",
  },
  contactSupport: {
    title: "Contact Support | Simplifyte",
    description:
      "Get help with your Simplifyte workspace, account, or workflow setup from our support team.",
    image: "https://www.simplifyte.com/og/support.jpg",
  },
  login: {
    title: "Log In to Simplifyte",
    description:
      "Sign in to your Simplifyte workspace to manage client-wise work, approvals, documents, and team workflows.",
    image: "https://www.simplifyte.com/og/login.jpg",
  },
  careers: {
    title: "Careers at Simplifyte | Build the Future With Us",
    description:
      "Join Simplifyte and help build workflow management software for CA firms and professional service teams across India.",
    image: "https://www.simplifyte.com/og/careers.jpg",
  },
  about: {
    title: "Why We Built Simplifyte | About Us",
    description:
      "Discover why we built Simplifyte — to end the workflow chaos that CA firms and professional service teams face with WhatsApp, email, and Excel.",
    image: "https://www.simplifyte.com/og/about.jpg",
  },
  academy: {
    title: "Simplifyte Academy | Guides & Tutorials",
    description:
      "Explore guides, tutorials, and practical help to get the most out of Simplifyte.",
    image: "https://www.simplifyte.com/og/academy.jpg",
  },
  changelog: {
    title: "What's New in Simplifyte | Changelog",
    description:
      "See the latest Simplifyte improvements, releases, and product updates.",
    image: "https://www.simplifyte.com/og/changelog.jpg",
  },
  brand: {
    title: "Brand Guidelines | Simplifyte",
    description:
      "View Simplifyte brand assets, logo rules, colors, and usage guidance.",
    image: "https://www.simplifyte.com/og/brand.jpg",
  },
  security: {
    title: "Security at Simplifyte | Data Protection for Professional Teams",
    description:
      "Learn how Simplifyte protects your client data, documents, and workflows with secure infrastructure, access controls, and audit trails.",
    image: "https://www.simplifyte.com/og/security.jpg",
  },
  features: {
    title: "Simplifyte Features | Workflow Tools for CA Firms & Professional Teams",
    description:
      "Explore Simplifyte features: client-wise work tracking, FY/period tracking, document collection, review workflows, approvals, reminders, audit trail and closure proof.",
    image: "https://www.simplifyte.com/og/features.jpg",
  },
  teamWorkflow: {
    title: "Team Collaboration & Workflow | Simplifyte",
    description:
      "Streamline team collaboration and workflow with Simplifyte — built for CA firms, tax consultants and professional service teams.",
    image: "https://www.simplifyte.com/og/teamworkflow.jpg",
  },
  customDashboard: {
    title: "Custom Dashboard | Simplifyte",
    description:
      "Get real-time visibility into your team's work, client status, and deadlines with Simplifyte's custom dashboards.",
    image: "https://www.simplifyte.com/og/customdashboard.jpg",
  },
  smartScheduling: {
    title: "Smart Scheduling & Deadline Tracking | Simplifyte",
    description:
      "Never miss a client filing deadline again. Simplifyte's smart scheduling keeps your CA firm on track.",
    image: "https://www.simplifyte.com/og/smartscheduling.jpg",
  },
  documentsOrganized: {
    title: "Document Management for CA Firms | Simplifyte",
    description:
      "Collect, organise, and track client documents with Simplifyte. Know exactly which documents are pending from which client.",
    image: "https://www.simplifyte.com/og/documentsorganized.jpg",
  },
  taskManagement: {
    title: "Task Management for Professional Teams | Simplifyte",
    description:
      "Assign, track, and close client work with Simplifyte's task management — designed for CA firms and professional service teams.",
    image: "https://www.simplifyte.com/og/taskmanagement.jpg",
  },
  officeHub: {
    title: "Office Hub | Simplifyte",
    description:
      "Manage attendance, timesheets, policies, and team requests from one central workspace.",
    image: "https://www.simplifyte.com/og/officehub.jpg",
  },
  bulkActions: {
    title: "AI-Enhanced Bulk Operations | Simplifyte",
    description:
      "AI-enhanced bulk uploads auto-classify and validate data for seamless integration.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  partners: {
    title: "Partners | Simplifyte",
    description:
      "Become a Simplifyte partner and grow your business with our workflow management platform.",
    image: "https://www.simplifyte.com/og/partners.jpg",
  },
  terms: {
    title: "Terms and Conditions | Simplifyte",
    description: "Read our terms and conditions for using Simplifyte services.",
    image: "https://www.simplifyte.com/og/legal.jpg",
  },
  privacy: {
    title: "Privacy Policy | Simplifyte",
    description: "Learn about how Simplifyte collects, uses, and protects your data.",
    image: "https://www.simplifyte.com/og/legal.jpg",
  },
  refund: {
    title: "Cancellation & Refund Policy | Simplifyte",
    description: "Information about our cancellation and refund policies.",
    image: "https://www.simplifyte.com/og/legal.jpg",
  },
  waitlist: {
    title: "Join the Simplifyte Waitlist",
    description:
      "Be the first to experience new features from Simplifyte — workflow management software for CA firms and professional teams.",
    image: "https://www.simplifyte.com/og/waitlist.jpg",
  },

  // Existing solution pages
  caFirms: {
    title: "Workflow Management Software for CA Firms | Simplifyte",
    description:
      "Simplifyte helps CA firms manage client-wise work, GST, income tax, audit, TDS, ROC filings, document collection, review notes, partner approvals and closure proof in one structured workspace.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  legalTeams: {
    title: "Workflow Software for Legal Teams & Advocates | Simplifyte",
    description:
      "Simplifyte helps advocates and legal teams manage case files, client communication, deadlines, billing, review workflows and closure proof in one workspace.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  itServices: {
    title: "Workflow Management for IT Service Teams | Simplifyte",
    description:
      "Simplifyte helps IT service teams manage support tickets, projects, client work, and team coordination in one structured workspace.",
    image: "https://www.simplifyte.com/preview.jpg",
  },

  // New solution pages
  solutionsCaFirms: {
    title: "Workflow Management Software for CA Firms in India | Simplifyte",
    description:
      "Simplifyte helps CA firms manage GST, income tax, audit, TDS, ROC, advisory workflows with client-wise work tracking, FY/period tracking, document collection, review notes, partner approvals and closure proof.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  solutionsTaxConsultants: {
    title: "Workflow Software for Tax Consultants | Simplifyte",
    description:
      "Simplifyte helps tax consultants manage client-wise income tax and GST workflows, document collection, deadline reminders, review approvals and closure proof — replacing WhatsApp and Excel chaos.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  solutionsAdvocates: {
    title: "Workflow Management for Advocates & Litigation Teams | Simplifyte",
    description:
      "Simplifyte helps advocates and litigation teams organise case files, track court dates, manage client communication, approvals and closure proof in one structured workspace.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  solutionsConsultants: {
    title: "Workflow Software for Consultants | Simplifyte",
    description:
      "Simplifyte helps consulting firms manage client-wise deliverables, period tracking, document collection, review workflows and closure proof — reducing follow-up chaos.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  solutionsProfessionalServices: {
    title: "Workflow Management for Professional Service Teams | Simplifyte",
    description:
      "Simplifyte is workflow management software built for professional service teams — manage client work, deadlines, documents, reviews, approvals, audit trail and closure proof in one workspace.",
    image: "https://www.simplifyte.com/preview.jpg",
  },

  // Feature pages
  featureClientWise: {
    title: "Client-Wise Work Tracking Software | Simplifyte",
    description:
      "Track every client's work by stage, owner, and status with Simplifyte. Know exactly where each GST return, income tax filing, audit, or deliverable stands — in real time.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  featureFYTracking: {
    title: "FY and Period-Based Workflow Tracking | Simplifyte",
    description:
      "Simplifyte lets CA firms and professional teams track work by financial year, quarter, and period — so no client filing or period is ever missed or duplicated.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  featureDocumentCollection: {
    title: "Document Collection & Pending Tracking | Simplifyte",
    description:
      "Track which documents are pending from which client with Simplifyte. Automated reminders replace WhatsApp follow-ups for document collection.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  featureReviewApproval: {
    title: "Review & Approval Workflow for CA Firms | Simplifyte",
    description:
      "Simplifyte's maker-checker workflow ensures every piece of work is reviewed before partner approval — with a full audit trail of who reviewed what and when.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  featureDeadlineReminders: {
    title: "Deadline Reminders for CA Firms & Professional Teams | Simplifyte",
    description:
      "Never miss a GST, income tax, TDS, or ROC filing deadline again. Simplifyte sends automated reminders to the right person at the right time.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  featureClosureProof: {
    title: "Closure Proof for Professional Work | Simplifyte",
    description:
      "Simplifyte generates timestamped closure proof for every completed piece of work — so your CA firm always has evidence of what was done, reviewed, approved, and delivered.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  featureAuditTrail: {
    title: "Audit Trail for Professional Service Workflows | Simplifyte",
    description:
      "Simplifyte maintains a complete audit trail of every action taken on every piece of work — who assigned it, who worked on it, who reviewed it, who approved it.",
    image: "https://www.simplifyte.com/preview.jpg",
  },

  // Comparison pages
  compareExcel: {
    title: "Excel vs Simplifyte | Workflow Management for CA Firms",
    description:
      "Excel is useful for data but not for accountability, reminders, audit trail and closure proof. See how Simplifyte replaces Excel for CA firm and professional service workflows.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  compareWhatsApp: {
    title: "WhatsApp vs Simplifyte | Structured Workflow for Professional Teams",
    description:
      "WhatsApp is useful for communication but not for structured workflows. See how Simplifyte replaces WhatsApp follow-ups for CA firms and professional service teams.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
  compareGenericTools: {
    title: "Generic Task Tools vs Simplifyte | Built for Professional Services",
    description:
      "Generic task tools are not built for client, FY, period, document status, review, approval and closure proof. See why Simplifyte is the right choice for CA firms.",
    image: "https://www.simplifyte.com/preview.jpg",
  },
};
